module.exports = __webpack_public_path__ + "static/the-watchmans-rattle-a33db7f49eb02c22107885a5181a3400.jpg";